// Mock data for B2B ESS Commercial Offer

export const partners = {
  kdmarche: {
    name: "KDMARCHE",
    role: "Opérateur commercial et logistique B2B",
    logo: "/logos/kdmarche-pro-gold.png",
    responsibilities: [
      "Opérateur de vente B2B",
      "Gestionnaire des catalogues produits",
      "Gestionnaire des stocks par zones",
      "Émetteur des factures marchandises",
      "Opérateur logistique (EXW, zones pays)",
      "Responsable de la conformité produit (TVA, douanes, DLC, traçabilité)"
    ],
    assumes: [
      "Le prix produit",
      "La relation fournisseur",
      "La facturation",
      "La TVA",
      "La livraison EXW"
    ]
  },
  oscop: {
    name: "O'SCOP",
    fullName: "Objectif SCOP Outremer",
    role: "Centrale coopérative d'ingénierie ESS, accès et mutualisation",
    logo: "/logos/oscop.webp",
    responsibilities: [
      "Centrale d'ingénierie d'achats ESS",
      "Organisateur de la mutualisation",
      "Opérateur de l'accès à la plateforme",
      "Gestionnaire des abonnements",
      "Gestionnaire du wallet crédits",
      "Garant du cadre ESS et coopératif"
    ],
    restrictions: [
      "Vend et facture en direct uniquement sur le circuit achat-revente O'SCOP",
      "N'encaisse jamais les ventes des partenaires vendeurs",
      "Assure les services coopératifs prévus sur le circuit partenaire",
      "Affiche le vendeur-facturier sur chaque offre"
    ]
  }
};

export const subscriptionPlans = [
  {
    id: "ess-acces-pro",
    name: "ESS ACCÈS PRO",
    price: 149,
    period: "mois",
    highlight: false,
    features: [
      "Accès à la Communityplace KDMARCHE B2B",
      "1 zone géographique incluse",
      "Accès aux prix structurels mutualisés",
      "CREDI'SCOP crédits de base",
      "Accès promos flash de la zone"
    ]
  },
  {
    id: "ess-volume-pro",
    name: "ESS VOLUME PRO",
    price: 349,
    period: "mois",
    highlight: true,
    popular: true,
    features: [
      "Accès prioritaire aux volumes",
      "Accès élargi aux gammes KDMARCHE",
      "CREDI'SCOP crédits renforcé",
      "Accès multi-catégories",
      "Reporting d'usage"
    ]
  },
  {
    id: "ess-impact-pro",
    name: "ESS IMPACT PRO",
    price: 749,
    period: "mois",
    highlight: false,
    features: [
      "Accès multi-zones",
      "Accès projets collectifs",
      "Reporting ESS / impact",
      "Appui structuration coopérative",
      "Accès fournisseurs stratégiques"
    ]
  }
];

export const logisticsSteps = [
  { step: "Accès plateforme", responsible: "O'SCOP" },
  { step: "Abonnement / crédits", responsible: "O'SCOP" },
  { step: "Catalogue produits", responsible: "KDMARCHE" },
  { step: "Prix produits", responsible: "KDMARCHE" },
  { step: "Facturation produits", responsible: "KDMARCHE" },
  { step: "Paiement produits", responsible: "KDMARCHE" },
  { step: "Transport (EXW)", responsible: "Client" }
];

export const exwJourney = [
  { step: "Accès et abonnement", responsible: "O'SCOP" },
  { step: "Catalogue et prix", responsible: "KDMARCHE O'SCOP PARTENAIRES" },
  { step: "Commande", responsible: "KDMARCHE O'SCOP PARTENAIRES" },
  { step: "Mise à disposition au point convenu", responsible: "KDMARCHE O'SCOP PARTENAIRES" },
  { step: "Règlement à l'enlèvement", responsible: "Client" },
  { step: "Transport organisé par l'acheteur", responsible: "Client" }
];

export const rarJourney = [
  { step: "Adhésion active", responsible: "O'SCOP" },
  { step: "Éligibilité et plafond", responsible: "KDMARCHE O'SCOP" },
  { step: "Commande sans acompte", responsible: "Client" },
  { step: "Réservation du montant sur le plafond disponible", responsible: "KDMARCHE O'SCOP PARTENAIRES" },
  { step: "Préparation et expédition", responsible: "KDMARCHE O'SCOP PARTENAIRES" },
  { step: "Livraison", responsible: "LOGI'SCOP" },
  { step: "Validation électronique de la réception", responsible: "Client" },
  { step: "Facturation et déclenchement du règlement", responsible: "KDMARCHE O'SCOP" },
  { step: "Réouverture du plafond après encaissement définitif", responsible: "KDMARCHE O'SCOP" }
];

export const walletCreditsUsage = [
  "L'usage intensif",
  "L'accès prioritaire",
  "Les zones supplémentaires",
  "Les services ESS"
];

export const compliancePoints = {
  guaranteed: [
    "Transparence totale des rôles",
    "Note préventive ACPR / DGCCRF intégrée"
  ],
  excluded: [
    "Aucune vente à perte (prix KDMARCHE économiquement justifiés)",
    "Aucune intermédiation financière",
    "Aucune activité d'assurance",
    "Aucune pratique commerciale trompeuse"
  ]
};

export const officialStatement = `Dans le cadre du partenariat KDMARCHE – O'SCOP, KDMARCHE assure la commercialisation des produits auprès des utilisateurs finaux, tandis qu'O'SCOP organise l'accès coopératif aux conditions économiques mutualisées. Les prix proposés s'inscrivent dans un cadre de mutualisation coopérative, fondé sur l'agrégation collective des volumes, des contributions et des services associés, et non sur une logique de remises commerciales individualisées.`;

export const priceAdvantages = [
  "Mutualisation organisée par O'SCOP",
  "Volumes consolidés",
  "Suppression d'intermédiaires",
  "Vente exclusivement B2B",
  "Modèle EXW sans coûts retail"
];

export const contractualDocuments = [
  "Convention de partenariat KDMARCHE – O'SCOP",
  "CG O'SCOP (accès & usage)",
  "CGV KDMARCHE B2B",
  "Charte ESS de mutualisation",
  "FAQ clients & administrations",
  "Page web commune \"Communityplace ESS\""
];

export const mockUsers = [
  {
    id: "1",
    email: "demo@oscop.fr",
    password: "demo123",
    name: "Entreprise Demo",
    company: "SARL Demo ESS",
    subscription: "ess-volume-pro",
    credits: 250
  }
];

export const mockQuoteRequests = [
  {
    id: "1",
    company: "Coopérative Solidaire",
    email: "contact@coop-solidaire.fr",
    phone: "0690123456",
    message: "Intéressés par l'offre ESS Volume Pro pour notre coopérative de 15 membres.",
    plan: "ess-volume-pro",
    createdAt: "2025-08-01T10:30:00Z",
    status: "pending"
  }
];
